import { useEffect, useState } from "react";
import { API, assetUrl } from "@/lib/api";

// One fetch per page load, shared by every component that needs the logo.
let cached;
let pending;

const load = () => {
  if (cached !== undefined) return Promise.resolve(cached);
  pending =
    pending ||
    fetch(`${API}/public/branding`)
      .then((r) => r.json())
      .then((d) => {
        cached = assetUrl(d?.logo_url) || null;
        return cached;
      })
      .catch(() => {
        cached = null;
        return null;
      });
  return pending;
};

export const clearBrandLogoCache = () => {
  cached = undefined;
  pending = undefined;
};

export function useBrandLogo() {
  const [logo, setLogo] = useState(cached === undefined ? null : cached);
  useEffect(() => {
    let alive = true;
    load().then((v) => alive && setLogo(v));
    return () => {
      alive = false;
    };
  }, []);
  return logo;
}
